import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { CloseStockOutModalTrackingEvent, PROJECT, TrackingEventName } from "./tracking";

interface TrackCloseStockOutModalFunction {
  (): void;
}

interface UseTrackCloseStockOutModalFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackCloseStockOutModalFunction {
  (agrs: UseTrackCloseStockOutModalFunctionArgs): TrackCloseStockOutModalFunction;
}

const useTrackCloseStockOutModal: UseTrackCloseStockOutModalFunction = ({ country, segment, tradename, userId }) => {
  const emitUserEvent = useEmitUserEvent<CloseStockOutModalTrackingEvent>();

  const trackCloseStockOutModal: TrackCloseStockOutModalFunction = useCallback(() => {
    emitUserEvent({
      event: TrackingEventName.CLOSE_STOCK_OUT_MODAL,
      eventCategory: TrackingEventCategory.LOOK_IN,
      store: country,
      section: PROJECT,
      segment,
      tradename,
      userId,
      userUuid: userId,
    });
  }, [country, emitUserEvent, segment, tradename, userId]);

  return trackCloseStockOutModal;
};

export { useTrackCloseStockOutModal };
